import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import CollectGender from './components/pages/CollectGender';
import CollectGoals from './components/pages/CollectGoals';
import CollectMotivations from './components/pages/CollectMotivations';
import CollectFitnessLevel from './components/pages/CollectFitnessLevel';
import CollectRunningHistory from './components/pages/CollectRunningHistory';
import CollectWalkingTime from './components/pages/CollectWalkingTime';
import CollectEndurance from './components/pages/CollectEndurance';
import CollectPersonalBest from './components/pages/CollectPersonalBest';
import CollectMusic from './components/pages/CollectMusic';
import BuildingProfile from './components/home/buildingProfile';
import { pathForPage } from './utils/pageType';
import SendToApp from './components/home/sendToApp';
import LandingPage from './components/home/landingPage';
import DynamicLinkPage from './components/DynamicLinkPage';
import ShareCodePage from './components/ShareCodePage';
import RedirectToMainWebsitePage from './components/RedirectToMainWebsitePage';
import DownloadPage from './components/DownloadPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RedirectToMainWebsitePage />}></Route>
        <Route
          path={pathForPage('GetStarted')}
          element={<LandingPage />}
        ></Route>
        <Route
          path={pathForPage('CollectGender')}
          element={<CollectGender />}
        ></Route>
        <Route
          path={pathForPage('CollectGoals')}
          element={<CollectGoals />}
        ></Route>
        <Route
          path={pathForPage('CollectMotivations')}
          element={<CollectMotivations />}
        ></Route>
        <Route
          path={pathForPage('CollectFitnessLevel')}
          element={<CollectFitnessLevel />}
        ></Route>
        <Route
          path={pathForPage('CollectRunningHistory')}
          element={<CollectRunningHistory />}
        ></Route>
        <Route
          path={pathForPage('CollectWalkingTime')}
          element={<CollectWalkingTime />}
        ></Route>
        <Route
          path={pathForPage('CollectEndurance')}
          element={<CollectEndurance />}
        ></Route>
        <Route
          path={pathForPage('CollectPersonalBest')}
          element={<CollectPersonalBest />}
        ></Route>
        <Route
          path={pathForPage('CollectMusic')}
          element={<CollectMusic />}
        ></Route>
        <Route
          path={pathForPage('BuildingProfile')}
          element={<BuildingProfile />}
        ></Route>
        <Route path={pathForPage('SendToApp')} element={<SendToApp />}></Route>
        <Route path="/dl/:shortPath" element={<DynamicLinkPage />} />
        <Route path="/code/:shareCodeValue" element={<ShareCodePage />} />
        <Route path="/download" element={<DownloadPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
